import React, { Component } from 'react';

export function addStore (Comp, stores) {

	return class extends Component {
		render () {
			return <Comp { ...stores } { ...this.props } />;
		}
	}
}

export function wrapGrid (Comp) {
	return class extends Component {
		render () {

			return (
				<div className="grid-x">

					<div className="auto cell">
						<Comp { ...this.props } />
					</div>

				</div>
			);
		}
	}
}
